module.exports = __webpack_public_path__ + "img/V-R-1-load-standup-base-shadow.c7e3a2ef.png";